export default class UserService {
    storeCoverage = (userId, data) => {
        return axios.post(`/users/${userId}/coverage`, data);
    };

    storeOperatives(userId, operatives) {
        return axios.post(`/users/${userId}/operatives`, {
            operatives,
        });
    }
}
